import * as React from 'react';

export type IsMobileScreenContextType = { isMobileScreen: boolean };

export default React.createContext<IsMobileScreenContextType>({ isMobileScreen: false });
